<template>
  <div class="company-info mod-job-info pega-comment-block">
    <preview-job-comments
      :comments="commentHighlights"
      :is-show="isShowComment"
      v-on="$listeners"
    />
    <div
      v-if="isShowTextCount"
      class="pega-count-moji-area"
    >
      <preview-text-count
        :name="title"
        :count-target="text"
      />
    </div>
    <dl
      data-test="company-detail"
      :class="{'not-first-child':!isFirstChild}"
    >
      <dt data-test="company-detail-title">
        {{ title }}
      </dt>
      <dd>
        <p
          :id="id"
          class="pega-pre-wrap"
          data-test="company-detail-text"
          v-text="text.value"
        />
      </dd>
    </dl>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/preview/pc/base" as *;

div.mod-job-info{
  margin: unset;
  .not-first-child dt, .not-first-child dd {
    border-top: 1px solid #bdbdbd !important;
  }
}
</style>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import PreviewTextCount from '@/components/atoms/PreviewTextCount'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  components: {
    PreviewJobComments,
    PreviewTextCount
  },
  mixins: [jobPreviewCommon],
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    isShowTextCount: {
      type: Boolean,
      required: true
    },
    isFirstChild: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
  }
}
</script>
